module.exports = __webpack_public_path__ + "static/electromobile-462925b917f56ee4d9976301f7f9ac61.webp";